import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import {Box, useSlotRecipe} from '@chakra-ui/react3'
import {flyoutNavigationRecipe} from '../../components/navigation/flyout/partials/flyout-navigation.recipe'
import FlyoutToolNav from '../../components/navigation/flyout/partials/flyout-tool-nav'
import {previewNavigationRecipe} from './index.recipe'

/**
 * The flyout's tool-nav row, in its real placement box, for one previewed pane.
 *
 * On desktop the row paints over the last band of the panes (STOK-17026 §4.1,
 * §5), which is what an editor checking a teaser column needs to see. On mobile
 * it belongs to the level-1 view alone, so a level-2 preview asks for
 * `desktopOnly`.
 *
 * @component
 * @param {Object} props
 * @param {boolean} [props.desktopOnly] - Hide the row on mobile.
 * @returns {JSX.Element}
 */
const NavigationPreviewToolNav = ({desktopOnly = false}) => {
    const recipe = useSlotRecipe({recipe: flyoutNavigationRecipe})
    const styles = useMemo(() => recipe(), [recipe])

    const previewRecipe = useSlotRecipe({recipe: previewNavigationRecipe})
    const previewStyles = useMemo(() => previewRecipe({desktopOnly}), [previewRecipe, desktopOnly])

    return (
        <Box css={[styles.toolNavContainer, previewStyles.toolNav]}>
            <FlyoutToolNav />
        </Box>
    )
}

NavigationPreviewToolNav.propTypes = {
    desktopOnly: PropTypes.bool
}

export default NavigationPreviewToolNav
